import { Slideshow, Flex, Icon, Span } from "@goodfill/ui-components";

interface InvestmentAssetInfoLabelProps {
  label: string;
}

interface InvestmentAssetInfo {
  label: string;
  percentage: number;
}

export const ustBills: InvestmentAssetInfo[] = [
  {
    label: "3MO",
    percentage: 4.66,
  },
  {
    label: "6MO",
    percentage: 4.84,
  },
  {
    label: "1YR",
    percentage: 4.75,
  },
];

export const ustBonds: InvestmentAssetInfo[] = [
  {
    label: "2YR",
    percentage: 4.61,
  },
  {
    label: "3YR",
    percentage: 4.31,
  },
  {
    label: "5YR",
    percentage: 4.0,
  },
  {
    label: "7YR",
    percentage: 3.88,
  },
  {
    label: "10YR",
    percentage: 3.74,
  },
  {
    label: "30YR",
    percentage: 3.77,
  },
];

const InvestmentAssetInfoLabel: React.FC<InvestmentAssetInfoLabelProps> = ({ label }) => (
  <Flex direction="row">
    <Flex width={24} />
    <Span white={true} font="bold">
      {label}
    </Span>
  </Flex>
);

const InvestmentAssetInfoItem: React.FC<InvestmentAssetInfo> = ({ label, percentage }) => (
  <Flex direction="row" items="center">
    <Span white={true} font="bold">{`${label}: ${percentage}% `}</Span>
    <Flex>
      {percentage >= 0 ? (
        <Span green={true}>
          <Icon name="triangle-up" size={18} />
        </Span>
      ) : (
        <Span red={true}>
          <Icon name="triangle-down" size={18} />
        </Span>
      )}
    </Flex>
  </Flex>
);

export const InvestmentAssetsFeed: React.FC = () => {
  return (
    <Slideshow duration={50}>
      <InvestmentAssetInfoLabel label="UST BILLS:" />
      {ustBills.map((props, i) => (
        <InvestmentAssetInfoItem key={i} {...props} />
      ))}

      <InvestmentAssetInfoLabel label="UST BONDS:" />
      {ustBonds.map((props, i) => (
        <InvestmentAssetInfoItem key={i} {...props} />
      ))}
    </Slideshow>
  );
};
